import React from 'react';
import { Button } from './Button';

// Barra de ação em lote (item 5 do diagnóstico de usabilidade) — some
// quando nada está selecionado, aparece grudada acima da tabela quando há
// seleção. Reaproveitada em toda listagem que já tem "arquivar" pronto no
// backend (Receitas/Despesas/Tarefas) — só chama em loop a partir dos ids
// selecionados, sem endpoint novo.
export function BulkActionBar({ count, onArquivar, onLimpar, processando }) {
  if (count === 0) return null;
  return (
    <div
      style={{
        display: 'flex', alignItems: 'center', gap: 'var(--crm-space-3)',
        padding: 'var(--crm-space-2) var(--crm-space-3)', marginBottom: 'var(--crm-space-2)',
        background: 'var(--crm-accent-soft, var(--crm-surface-hover))', border: '1px solid var(--crm-accent)',
        borderRadius: 'var(--crm-radius-md)', fontSize: 'var(--crm-text-sm)',
      }}
    >
      <span>{count} selecionado{count > 1 ? 's' : ''}</span>
      <Button size="sm" variant="outline" loading={processando} onClick={onArquivar}>Arquivar selecionados</Button>
      <Button size="sm" variant="ghost" onClick={onLimpar}>Limpar seleção</Button>
    </div>
  );
}

export default BulkActionBar;
